// ─────────────────────────────────────────────────────────────────────────────
// RoleLabel (Contacts), the crew-row role sub-line. Mirrors the AV-tier pattern
// from BandSwitcher.tsx / role-perms.js getRoleDisplayHTML: 'band_member_av'
// renders "Band Member" + the CNTRL mark, NOT "band member av". Other roles are
// underscore-stripped + title-cased.
//
// CD's Contacts mock renders the AV mark as <span class="av-mark">+</span> (the
// crimson "+" styled in contacts.css:561), which is CD's exact spec for this
// screen, so this component emits CD's .av-mark markup rather than the
// BandSwitcher's <img.role-av-mark>. The LOGIC (which roles get the mark, the
// title text) mirrors RoleLabel in BandSwitcher.tsx verbatim.
// ─────────────────────────────────────────────────────────────────────────────

import type { JSX } from 'react';

export interface RoleLabelProps {
  readonly role?: string;
}

export function RoleLabel({ role }: RoleLabelProps): JSX.Element | null {
  const r = String(role || '').toLowerCase();
  if (!r) return null;
  if (r === 'band_member_av') {
    return (
      <>
        Band Member
        <img className="role-av-mark" src="/brand/logo-mark.svg" alt="" aria-hidden="true" />
      </>
    );
  }
  /* acpro-teams 2026-07-27 — acronym-heavy Pro seats break plain
     title-casing ("Foh Systems Tech", "Rf Tech", "Pa Tech 1"). */
  const OVERRIDE: Record<string, string> = {
    foh_engineer: 'FOH Engineer',
    foh_systems_tech: 'FOH Systems Tech',
    rf_tech: 'RF Tech',
    pa_tech_1: 'PA Tech 1',
    pa_tech_2: 'PA Tech 2',
  };
  if (OVERRIDE[r]) return <>{OVERRIDE[r]}</>;
  return <>{r.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}</>;
}
